import { Injectable, Inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { UrlService } from '../url/url.service';
import { AppState } from '@store/state';
import { AffiliateOptions, AffiliateOption } from './_interfaces_/affiliate-options.interface';
import { UrlEnum } from '@enums/url.enum';
import * as AffiliateOptionsActions from '@store/affiliate-options/affiliate-options.actions';

@Injectable({
  providedIn: 'root'
})
export class AffiliateService {
  constructor(
    @Inject(HttpClient) private _http: HttpClient,
    @Inject(Store) private _store: Store<AppState>,
    @Inject(UrlService) private _urlService: UrlService
  ) {}

  getAffiliateOptions(): Observable<AffiliateOption[]> {
    const url = this._urlService.urls[UrlEnum.GET_AFFILIATE_OPTIONS];

    return this._http.get<AffiliateOptions>(url).pipe(
      map(data => data.AffiliateOptions),
      tap(data => this._store.dispatch(AffiliateOptionsActions.setAffiliateOptions({ data })))
    );
  }
}
